import { render, staticRenderFns } from "./LoaderUniColorNew.vue?vue&type=template&id=b8b8808e&scoped=true"
import script from "./LoaderUniColorNew.vue?vue&type=script&lang=js"
export * from "./LoaderUniColorNew.vue?vue&type=script&lang=js"
import style0 from "./LoaderUniColorNew.vue?vue&type=style&index=0&id=b8b8808e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b8808e",
  null
  
)

export default component.exports